module.exports = {"domain":"svw.auth0.com","clientId":"KZID5m7b2zbBpA0e7BSsVvawPvKqsmeG"}


//////////////////
// WEBPACK FOOTER
// ./auth_config.json
// module id = kMb3
// module chunks = 1